export default "__VITE_ASSET__Cs8zbQ3Q__"